import { useEffect } from 'react';
import GitHubCalendar from 'github-calendar';
import 'github-calendar/dist/github-calendar-responsive.css';
import { Link } from 'react-router-dom';
import { T } from './Translator';

function Projects() {
  useEffect(() => {
    GitHubCalendar(".calendar", "koppieesq", {
      responsive: true,
      tooltips: true
    });
  }, []);

  return (
    <div className="projects main-content">
      <h2><T>Drupal</T></h2>
      <p><Link to="https://www.drupal.org/u/koppie"><T>Drupal.org profile</T></Link></p>
      <h2><T>GitHub</T></h2>
      <p><Link to="https://github.com/koppieesq"><T>GitHub.com profile</T></Link></p>
      <div className="calendar main-content"><T>Loading...</T></div>
      <h2><T>Packages</T></h2>
      <p><Link to="https://packagist.org/packages/koppie/"><T>Packagist profile</T></Link></p>
      <p><Link to="https://www.npmjs.com/~koppieesq"><T>NPM profile</T></Link></p>
    </div>
  );
}

export default Projects;
